<template>
  <div class="wrap">
    <el-form
      :model="ruleForm"
      :rules="rules2"
      ref="ruleForm"
      label-position="top"
      class="demo-ruleForm login-container"
    >
      <div class="logo"></div>
      <h3 class="title">Task Dispatch Admin System</h3>
      <div class="input-wrap">
        <el-form-item prop="account" label="Username">
          <el-input
            type="text"
            v-model="ruleForm.account"
            auto-complete="off"
            placeholder="Username"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password" label="Password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            auto-complete="off"
            placeholder="Password"
            size="small"
          ></el-input>
        </el-form-item>
        <br />
        <el-form-item>
          <el-button
            type="primary"
            style="width: 100%;background-color: #E95646"
            @click="handleSubmit2"
            :loading="logining">Login</el-button>
        </el-form-item>
        <p class="forgot" @click="forgotTip">Forgot Password</p>
      </div>
    </el-form>
  </div>
</template>

<script>
import {adminLogin} from "@/api/login";
export default {
  data() {
    return {
      logining: false,
      ruleForm: {
        account: '',
        password: '',
        verifyCode: '',
      },
      rules2: {
        account: [{ required: true, message: ' ', trigger: 'blur' }],
        password: [{ required: true, message: ' ', trigger: 'blur' }],
      },
      flag: true,
    };
  },

  methods: {
    forgotTip() {
      this.$message({
        message: 'Please contact your sales representative',
        type: 'warning'
      });
    },
    handleSubmit2(ev) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.logining = true;
          let params = {
            username: this.ruleForm.account,
            password: this.ruleForm.password,
          };
          adminLogin(params)
            .then((res) => {
              this.logining = false;
              let value = res;
              if (value.code == 200) {
                localStorage.setItem('token', value.data.token);
                localStorage.setItem('userInfoDetail', JSON.stringify(value.data.admin));
                this.$router.push({ path: '/' });
              } else {
                this.$message({
                  message: value.msg,
                  type: 'error',
                });
              }
            })
            .catch((err) => {
              this.$message({
                message: err.msg,
                type: 'error',
              });
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  text-align: left;
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  /deep/ .el-button{
    border: none;
  }
}

.login-container {
  width: 520px;
  padding: 2px 35px 15px 35px;
  background-color: #fff;

  .logo {
    width: 148px;
    height: 88px;
    background: url('../assets/login/logo.png') no-repeat;
    background-size: 100% 100%;
    margin: 0 auto 25px;
  }

  .title {
    margin: 0px auto 20px auto;
    text-align: center;
    font-size: 32px;
    font-family: Poppins-Bold, Poppins;
    font-weight: 600;
    color: #e95646;
  }

  .remember {
    margin: 0px 0px 35px 0px;
  }
}

.backLogin {
  color: #409eff;
  cursor: pointer;
  text-align: center;
}

.verifyCode {
  display: flex;
  align-items: center;
  justify-content: center;

  .input {
    width: 65%;
  }

  .img {
    width: 32%;
    margin-left: 3%;
    display: flex;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.input-wrap {
  width: 70%;
  margin: 0 auto;
}

.forgot {
  color: #e95646;
  font-size: 14px;
  font-family: Poppins-Bold, Poppins;
  font-weight: 500;
  text-align: center;
  cursor: pointer;
}
</style>
